/**
 * 计算表达式是否成立
 * @param operator 运算符
 * @param value 值
 * @param targetValue   对比值
 */
export function compareByOperator(operator, value, targetValue){
    if(operator === '='){
        return value == targetValue;//不判断类型
    }
    let val = 0
    try {
        val = parseInt(value)
        switch (operator) {
            case '>':
                return val > targetValue
            case '<':
                return val < targetValue
            case '=':
                return val === targetValue
            case '>=':
                return val >= targetValue
            case '<=':
                return val <= targetValue
        }
    }catch (e) {
        return false
    }
    return false;
}